import { RouteObject } from 'react-router-dom';
import Dashboard from './components/dashboard/dashboard';

export interface CxDashboardRoute extends Omit<RouteObject, 'children'> {
  auth?: boolean;
  children?: CxDashboardRoute[];
}

export const dashboardRoutes: CxDashboardRoute[] = [
  {
    path: '/cx/dashboard',
    element: <Dashboard />,
  },
];
